export default "__VITE_ASSET__DLzjRNKR__"